import React from "react";
import { Box, Paper, Typography, useTheme, Grid, Divider, IconButton, CircularProgress } from "@mui/material";
import { tokens } from "../../theme";

import { useEffect, useState } from "react";
import { comissionHandler } from "../../utils/comission-handler";

import DeleteIcon from "@mui/icons-material/Delete";
import { djangoApi } from "../../utils/axios/axios.utils";
import toast from "react-hot-toast";



const KitComissionPage = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { 
        totalSoldProdsValue,
        totalPaidToPitaya,
        formType,
        valueForComission,
        valueForComissionVeludos,
        valueForComissionSacolas,
        voucherData,
        setVoucherData ,
        data, 
        setData
        }
        = props

    const [isLoadingDeleteVoucher, setIsLoadingDeleteVoucher] = useState(null);
    const [totalValueVouchers, setTotalValueVouchers] = useState(0);
    const [totalValueAnteriores, setTotalValueAnteriores] = useState(0);

    const formatNumber = (data) => {
        return data?.toLocaleString(
            "pt-br",
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        )
    }

    useEffect(() => {
        if (voucherData?.length > 0) {
            const totalVoucher = voucherData?.filter((data) => data?.tipo === 'Voucher').reduce((acc, curr) => acc += parseFloat(curr.value),0)
            const totalAnteriores = voucherData?.filter((data) => data?.tipo !== 'Voucher').reduce((acc, curr) => acc += parseFloat(curr.value),0)
            setTotalValueVouchers(totalVoucher)
            setTotalValueAnteriores(totalAnteriores)
        } else {
            setTotalValueVouchers(0)
            setTotalValueAnteriores(0)
        }
    }, [voucherData]);

    // const [data, setData] = useState({
    //     sale: totalSoldProdsValue,
    //     commission: comissionHandler(valueForComission),
    //     veludos: valueForComissionVeludos,
    //     sacolas: valueForComissionSacolas,
    //     total: totalSoldProdsValue - comissionHandler(valueForComission) + valueForComissionVeludos + valueForComissionSacolas - totalValueVouchers,
    //     alreadyPaid: totalPaidToPitaya,
    //     toPay: totalSoldProdsValue - totalPaidToPitaya - comissionHandler(valueForComission) + valueForComissionVeludos + valueForComissionSacolas + totalValueAnteriores - totalValueVouchers,
    // });

    useEffect(() => {
        setData({
        sale: totalSoldProdsValue,
        commission: comissionHandler(valueForComission - totalValueVouchers),
        veludos: valueForComissionVeludos,
        sacolas: valueForComissionSacolas,
        total: totalSoldProdsValue - comissionHandler(valueForComission - totalValueVouchers) + valueForComissionVeludos + valueForComissionSacolas - totalValueVouchers,
        alreadyPaid: totalPaidToPitaya,
        toPay: totalSoldProdsValue - totalPaidToPitaya - comissionHandler(valueForComission - totalValueVouchers) + valueForComissionVeludos + valueForComissionSacolas + totalValueAnteriores - totalValueVouchers,
        })
    }, []);

    useEffect(() => {
        setData({
            sale: totalSoldProdsValue,
            commission: comissionHandler(valueForComission - totalValueVouchers),
            veludos: valueForComissionVeludos,
            sacolas: valueForComissionSacolas,
            total: totalSoldProdsValue - comissionHandler(valueForComission - totalValueVouchers) + valueForComissionVeludos + valueForComissionSacolas - totalValueVouchers,
            alreadyPaid: totalPaidToPitaya,
            toPay: totalSoldProdsValue - totalPaidToPitaya - comissionHandler(valueForComission - totalValueVouchers) + valueForComissionVeludos + valueForComissionSacolas + totalValueAnteriores - totalValueVouchers,
        })
    }, [totalSoldProdsValue, totalPaidToPitaya, valueForComission, valueForComissionVeludos, valueForComissionSacolas, totalValueVouchers, totalValueAnteriores]);


    useEffect(() => {
        if (formType === 'Criando') {
            setData({
                sale: 0,
                commission: 0,
                veludos: 0.0,
                sacolas: 0.0,
                total: 0,
                alreadyPaid: 0,
                toPay: 0,
            })
        }
    }, [formType]);

    const deleteVoucher = async (pk) => {
        setIsLoadingDeleteVoucher(pk)
        try {
            const response = await djangoApi
                .post(`products/kit_voucher/${pk}/delete_kit_vouchers/`, {}, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            return response
        } catch (err) {
            console.log("Erro ao pegar os dados", err);
            window.alert(err);
            setIsLoadingDeleteVoucher(null)
        } finally {
            // pass
            setIsLoadingDeleteVoucher(null)
        }
    };

    const handleDelete = async (voucher) => {
        console.log('voucher', voucher)
        const deletedVoucher = await deleteVoucher(voucher.id)
        console.log('deleted voucher', deletedVoucher)
        if (deletedVoucher.status === 201) {
            toast.success(
                `${voucher.tipo} deletado com sucesso!!`,
                {
                    position: 'top-right'
                }
            );
            setVoucherData((prev) => {
                return prev.filter((data) => data.id !== voucher.id)
            })
        }
    }

    return (
        <Paper
            component={Box}
            elevation={10}
            sx={{
                maxWidth: '400px',
                padding: '16px',
                // borderRadius: '8px',
                // backgroundColor: '#f5f5f5',
                // boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                backgroundColor: colors.pink[800],
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 'bold',
                    marginBottom: '16px',
                    color: 'whitesmoke',
                }}
            >
                Resumo de Pagamento
            </Typography>
            <Grid container spacing={2}>
                {/* Sale */}
                <Grid item xs={8}>
                    <Typography sx={{ fontWeight: 'bold' }}>Venda (+)</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography align="right" sx={{ fontWeight: 'bold' }}>R$ {formatNumber(data.sale)}</Typography>
                </Grid>
                {/* VOUCHER SECTION */}
                {
                    voucherData?.filter((data) => data?.tipo === 'Voucher')?.length > 0 &&
                    voucherData.filter((data) => data?.tipo === 'Voucher').map((vouch, i) => {
                        return (
                            <>

                                <React.Fragment key={i}>
                                {
                                        i === 0 &&
                                        <Divider sx={{ width: "100%" }} />
                                    }
                                    <Grid
                                        container
                                        alignItems="center"
                                        spacing={1}
                                        sx={{
                                            "&:hover .delete-icon": { visibility: "visible" },
                                        }}
                                    >
                                        {/* Voucher Type */}
                                        <Grid item xs={7}>
                                            <Typography sx={{ marginLeft: '15px', fontWeight: 'bold' }}>{vouch.tipo} ({parseFloat(vouch.value) < 0 ? "+" : "-"})</Typography>
                                        </Grid>

                                        {/* Value */}
                                        <Grid item xs={4}>
                                            <Typography align="right" sx={{ marginRight: '-33px', fontWeight: 'bold' }}>R$ {formatNumber(parseFloat(vouch.value < 0 ? vouch.value * -1 : vouch.value))}</Typography>
                                        </Grid>

                                        {/* Trash Icon */}
                                        <Grid
                                            item
                                            xs={1}
                                            sx={{
                                                display: "flex",
                                                // justifyContent: "flex-end",
                                            }}
                                        >
                                            {isLoadingDeleteVoucher === vouch.id ? (
                                                <CircularProgress size={24} color="error" />
                                            ) : (
                                                <IconButton
                                                    className="delete-icon"
                                                    sx={{
                                                        visibility: "hidden", // Hidden by default
                                                    }}
                                                    onClick={() => handleDelete(vouch)}
                                                >
                                                    <DeleteIcon color="error" />
                                                </IconButton>
                                            )}
                                        </Grid>
                                    </Grid>
                                    {
                                        i + 1 === voucherData?.filter((data) => data?.tipo === 'Voucher')?.length &&
                                        <Divider sx={{ width: "100%" }} />
                                    }
                                </React.Fragment>

                            </>
                        )
                    })
                }
                {
                    voucherData?.filter((data) => data?.tipo === 'Voucher')?.length > 0 &&
                    <>
                        <Grid item xs={8}>
                            <Typography sx={{ fontWeight: 'bold' }}>Total (=)</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography align="right" sx={{ fontWeight: 'bold' }}>R$ {formatNumber(data.sale - totalValueVouchers)}</Typography>
                        </Grid>
                    </>
                }
                <Divider sx={{ width: '100%' }} />
                {/* Commission */}
                <Grid item xs={8}>
                    <Typography>Comissão (-)</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography align="right">R$ {formatNumber(data.commission)}</Typography>
                </Grid>
                {/* Veludos */}
                <Grid item xs={8}>
                    <Typography>Veludos (+)</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography align="right">R$ {formatNumber(data.veludos)}</Typography>
                </Grid>
                {/* Sacolas */}
                <Grid item xs={8}>
                    <Typography>Sacolas (+)</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography align="right">R$ {formatNumber(data.sacolas)}</Typography>
                </Grid>
                <Divider sx={{ width: '100%' }} />
                {/* Total */}
                <Grid item xs={8}>
                    <Typography sx={{ fontWeight: 'bold' }}>Valor Total Acerto (=)</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography align="right" sx={{ fontWeight: 'bold' }}>
                        R$ {formatNumber(data.total)}
                    </Typography>
                </Grid>
                {/* Already Paid */}
                <Grid item xs={8}>
                    <Typography>Já Pago à Pitaya (-)</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography align="right">R$ {formatNumber(data.alreadyPaid)}</Typography>
                </Grid>
                <Divider sx={{ width: '100%' }} />

                {/* VOUCHER SECTION */}
                {
                    voucherData?.filter((data) => data?.tipo !== 'Voucher')?.length > 0 &&
                    voucherData.filter((data) => data?.tipo !== 'Voucher').map((vouch, i) => {
                        return (
                            <>

                                <React.Fragment key={i}>
                                    <Grid
                                        container
                                        alignItems="center"
                                        spacing={1}
                                        sx={{
                                            "&:hover .delete-icon": { visibility: "visible" },
                                        }}
                                    >
                                        {/* Voucher Type */}
                                        <Grid item xs={7}>
                                            <Typography sx={{ marginLeft: '15px', fontWeight: 'bold' }}>{vouch.tipo} ({parseFloat(vouch.value) > 0 ? "+" : "-"})</Typography>
                                        </Grid>

                                        {/* Value */}
                                        <Grid item xs={4}>
                                            <Typography align="right" sx={{ marginRight: '-33px', fontWeight: 'bold' }}>R$ {formatNumber(parseFloat(vouch.value < 0 ? vouch.value * -1 : vouch.value))}</Typography>
                                        </Grid>

                                        {/* Trash Icon */}
                                        <Grid
                                            item
                                            xs={1}
                                            sx={{
                                                display: "flex",
                                                // justifyContent: "flex-end",
                                            }}
                                        >
                                            {isLoadingDeleteVoucher === vouch.id ? (
                                                <CircularProgress size={24} color="error" />
                                            ) : (
                                                <IconButton
                                                    className="delete-icon"
                                                    sx={{
                                                        visibility: "hidden", // Hidden by default
                                                    }}
                                                    onClick={() => handleDelete(vouch)}
                                                >
                                                    <DeleteIcon color="error" />
                                                </IconButton>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Divider sx={{ width: "100%" }} />
                                </React.Fragment>

                            </>
                        )
                    })
                }

                {/* To Pay */}
                <Grid item xs={8}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                        {data.toPay < 0 ? "A Devolver para você (=)" : "À Pagar Para Pitaya (=)"}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography align="right" sx={{ fontWeight: 'bold' }}>
                        R$ {formatNumber(data.toPay < 0 ? data.toPay * -1 : data.toPay)}
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default KitComissionPage;